import { createStore } from '@shared/store';
import { CaseIDProps, ServiceLocationDetailsObjectType } from '@types';
import { CheckboxOption } from '@molecules/*';
import { addressResponseType } from '@utils';

export type DateFieldType = string | number;
export type SelectedDateTime = {
  selectedYear: DateFieldType;
  selectedMonth: DateFieldType;
  selectedDay: DateFieldType;
  selectedHour: DateFieldType;
  selectedMinute: DateFieldType;
};

export interface IssueLocationDetailsObjectType {
  address_line_1: string;
  address_line_2: string;
  town_city: string;
  county: string;
  postcode: string;
  country: string;
  UPRN: string;
  USRN: string;
  latitude: string;
  longitude: string;
}

interface UploadPhotoTypes {
  uploadedImages: string[];
  uploadedImagesFileName: string[];
  uploadedImagesFileType: string[];
  uploadedImagesBlob: {
    blob_uri: string;
    blob_endpoint: string;
    filename: string;
  }[];
  serviceLocationDetailsFromFile: ServiceLocationDetailsObjectType;
  fileWithLoadedCoordinates: string;
  isPhotoLocationStored: boolean;
  describeTheIssue: string;
  describeThePerformer: string;
  contactUserOption: string;
  receiveConfirmationEmail: string;
  isIssueHappeningNow: string;
  issueTypes: CheckboxOption[];
  issueLocationData: addressResponseType;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  confirmation: CaseIDProps | undefined;
  sessionId: string;
  selectedDateTime: SelectedDateTime;
  dateTime: string;
}

export const emptyLocation = {
  address_line_1: '',
  address_line_2: '',
  country: '',
  county: '',
  easting: '',
  latitude: '',
  longitude: '',
  northing: '',
  postcode: '',
  town: '',
  asset: undefined,
  UPRN: '',
  USRN: '',
  full_address: '',
};
export const useBuskingStore = createStore<UploadPhotoTypes>({
  initialData: {
    uploadedImages: [],
    uploadedImagesFileName: [],
    uploadedImagesFileType: [],
    uploadedImagesBlob: [],
    serviceLocationDetailsFromFile:
      [] as unknown as ServiceLocationDetailsObjectType,
    fileWithLoadedCoordinates: '',
    isPhotoLocationStored: false,
    describeTheIssue: '',
    describeThePerformer: '',
    contactUserOption: '',
    isIssueHappeningNow: '',
    receiveConfirmationEmail: '',
    issueTypes: [],
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    confirmation: undefined,
    selectedDateTime: {
      selectedDay: '',
      selectedMonth: '',
      selectedYear: '',
      selectedMinute: '',
      selectedHour: '',
    },
    dateTime: '',
    sessionId: '',
    issueLocationData: emptyLocation,
  },
  name: 'busking-store',
  persist: true,
  enableDevTools: false,
});
